<template>
  <div class="showSettings">
    <Checkbox
      name="show"
      :title="$t('showUpperCase')"
      :value="value"
      @change="selectOption(value)"
    />
    <div class="showSettings__positions">
      <p class="title-positions">{{ $t('position') }}</p>
      <Dropdown
        class="dropdown-positions"
        :selected-option="selectedPositions.selectedOption"
        :options="selectedPositions.options"
        @select-option="selectPositions"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import { mapScreensToSelectedPositions } from './configs';
import { optionsPositions } from './configs';

import { Option } from '@/types';

@Options({
  name: 'ShowSettings',
  props: ['value', 'selectedOption'],
  data() {
    return {
      screens: {},
      name: '',
      positionNumber: 0,
      selectedPositions: {
        selectedOption: {},
        options: optionsPositions
      }
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  created() {
    if (this.pharmacy) {
      this.show();
    }
  },
  methods: {
    show() {
      this.loading = true;

      if (this.pharmacy) {
        this.screens = this.pharmacy.feedbackTemplate;
        this.name = this.$route.name.toLowerCase();

        this.selectedPositions.selectedOption = mapScreensToSelectedPositions(
          this.screens,
          this.name
        );
      }

      this.loading = false;
    },
    selectOption(value: boolean) {
      // eslint-disable-next-line
      value = !value;
    },
    selectPositions(option: Option) {
      this.selectedPositions.selectedOption = option;
      this.$emit('update:selectedPosition', option.value);
    }
  },
  watch: {
    pharmacy() {
      if (this.pharmacy) {
        this.show();
      }
    }
  }
})
export default class ShowSettingsComponent extends Vue {}
</script>

<style lang="scss">
.showSettings {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .showSettings__positions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 100px;
    .title-positions {
      font-size: 16px;
      margin-right: 15px;
    }
    .dropdown-positions {
      width: 104px;
      height: 30px;
    }
  }
}

.checkbox .checkbox-label[data-v-98132038] {
  font-size: 16px;
}
</style>
